<template>
  <div class="warpper">
    <el-input
      placeholder="请输入内容"
      v-model="search"
      class="input-with-select"
    >
      <el-button
        slot="append"
        icon="el-icon-search"
        @click="serchBten"
      ></el-button>
    </el-input>
    <!--         :filter-node-method="filterNode" -->
    <el-tree
      ref="tree"
      :data="TreeData"
      node-key="uuid"
      :filter-node-method="filterNode"
      :highlight-current="true"
      :default-expanded-keys="defaulttree"
      :default-checked-keys="defaulttree"
      :props="defaultProps"
      :default-expand-all="isExpand"
      @node-click="handleNodeClick"
    >
      <span class="custom-tree-node" slot-scope="{ node, data }">
        <span class="netlnt">
          <!-- <i :class="data.class"> </i> -->

          <img :src="data.class" class="imgsne" alt />
          <span>{{ data.lable }}</span>
        </span>
      </span>
    </el-tree>
    {{ keystreeList }}
  </div>
</template>

<script>
import { treeinfo } from "../../../network/index";
import { baojing, zhenchangtupian, lixiantupian } from "@/network/baserURL";
export default {
  props: {
    defaulttree: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      TreeData: [],
      show: true,
      search: "",
      isExpand: false,
      roletype: sessionStorage.getItem("roletypeValue"),
      defaultProps: {
        children: "child",
        label: "lable",
      },
      treeKey: "",
      valueinsts: "",
      zhenchangtupian: zhenchangtupian,
    };
  },
  created() {
    this.treeinfo();
  },
  mounted(){
    // this.treeinfo();
  },
  computed: {
    // 默认打开当前打开的树
    keystreeList() {
      if (this.defaulttree != undefined) {
        this.treeinfo();
        let keys = this.defaulttree[0];
        setTimeout(() => {
          this.$refs.tree.setCurrentKey(keys);
        }, 1000);
      }
    },
  },
  watch: {
    // search(val) {
    //   this.$refs.tree.filter(val);
    // },
    
  },
  methods: {
    serchBten() {
      this.$refs.tree.filter(this.search);
    },
    // 树形控件搜索
    filterNode(value, data, node) {
      if (!value) {
        return true;
      }
      let level = node.level;
      let _array = []; //这里使用数组存储 只是为了存储值。
      this.getReturnNode(node, _array, value);
      let result = false;
      _array.forEach((item) => {
        result = result || item;
      });
      return result;
    },
    //树形控件搜索
    getReturnNode(node, _array, value) {
      let isPass =
        node.data && node.data.lable && node.data.lable.indexOf(value) !== -1;
      isPass ? _array.push(isPass) : "";
      this.index++;
      // console.log(this.index);
      if (!isPass && node.level != 1 && node.parent) {
        this.getReturnNode(node.parent, _array, value);
      }
    },
    //展示省市区经销商客户
    mycityHande(e) {
      switch (e) {
        case "province": //省
          // 全部折叠
          for (
            let i = 0;
            i < this.$refs.tree.store._getAllNodes().length;
            i++
          ) {
            this.$refs.tree.store._getAllNodes()[i].expanded = false;
          }

          break;

        case "city": //市
          let cityArr = [];

          // 折叠区域
          this.TreeData.forEach((item, index) => {
            item.child.forEach((item1, index1) => {
              //折叠上
              this.$refs.tree.store.nodesMap[item1.uuid].expanded = false;
            });
          });

          this.TreeData.forEach((item, index) => {
            //展开
            cityArr.push(item.uuid);
          });

          this.$emit("countClickTree", cityArr);
          break;

        case "county": //区县
          let countyArr = [];
          this.cityCint = true; //折叠

          this.TreeData.forEach((item) => {
            item.child.forEach((item1) => {
              //  console.log(this.$refs.tree.store.nodesMap[item1.uuid].expanded = true);
              countyArr.push(item1.uuid);
            });
          });
          //  this.keystree = countyArr;
          this.$emit("countClickTree", countyArr);
          /**折叠经销商 */
          this.TreeData.forEach((item) => {
            item.child.forEach((item1) => {
              item1.child.forEach((item2) => {
                this.$refs.tree.store.nodesMap[item2.uuid].expanded = false;
              });
            });
          });

          break;
        case "dealer_uuid": //经销商
          let dealer_uuids = [];
          this.TreeData.forEach((item) => {
            item.child.forEach((item1) => {
              item1.child.forEach((item2) => {
                dealer_uuids.push(item2.uuid);
              });
            });
          });
          this.$emit("countClickTree", dealer_uuids);

          // 关闭客户
          this.TreeData.forEach((item) => {
            item.child.forEach((item1) => {
              item1.child.forEach((item2) => {
                item2.child.forEach((item3) => {
                  // console.log(item3);
                  this.$refs.tree.store.nodesMap[item3.uuid].expanded = false;
                });
              });
            });
          });
          break;

        case "customer_uuid": //客户
          let customer_uuids = [];
          this.TreeData.forEach((item) => {
            item.child.forEach((item1) => {
              item1.child.forEach((item2) => {
                item2.child.forEach((item3) => {
                  // console.log(item3);
                  customer_uuids.push(item3.uuid);
                });
              });
            });
          });
          this.$emit("countClickTree", customer_uuids);

              this.TreeData.forEach((item) => {
            item.child.forEach((item1) => {
              item1.child.forEach((item2) => {
                 item2.child.forEach((item3) => {
                  item3.child.forEach((item4)=>{
                    // console.log(item4);
                      this.$refs.tree.store.nodesMap[item4.uuid].expanded = false;
                  })
                });
              });
            });
          });
          
          break;
          // 网关
          case 'gateway_uuid':
            let carrUiid = []
          this.TreeData.forEach((item) => {
            item.child.forEach((item1) => {
              item1.child.forEach((item2) => {
                 item2.child.forEach((item3) => {
                  item3.child.forEach((item4)=>{
                    // console.log(item4);
                    carrUiid.push(item4)
                  })
                });
              });
            });
          });
            this.$emit("countClickTree", carrUiid);
          break
          
      }
    },
    handleNodeClick: function (data, checked) {
      if (data.gateway_uuid != undefined) {
        // console.log(data);
        this.$emit("getUuidclick", data.gateway_uuid);
      }
      // 点击事件
    },
    handleCheckChange(data, checked, indeterminate) {
      console.log(data, checked, indeterminate);
    },
    async treeinfo(serch) {
      let levelid = 4;
      const { code, data, msg } = await treeinfo(levelid, serch);
      if (code) {
        this.TreeData = data;
      }
    },
  },
};
</script>

<style scoped>
.warpper
  .el-tree--highlight-current
  /deep/
  .el-tree-node.is-checked
  > .el-tree-node__content {
  /* background-color: rgb(255, 255, 255); */
  /* color: rgb(64, 158, 255); */
  width: 100%;
}
.warpper .el-tree {
  width: 100% !important;
}
.warpper
  .el-tree--highlight-current
  /deep/
  .el-tree-node.is-current
  > .el-tree-node__content {
  /* background-color: rgb(255, 255, 255); */
  color: #fff;
}
.imgsne {
  padding: 0 10px;
}
.netlnt {
  display: flex;
  align-items: center;
}
</style>